(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("sbPolyfills", [], factory);
	else if(typeof exports === 'object')
		exports["sbPolyfills"] = factory();
	else
		root["sbPolyfills"] = factory();
})(window, function() {
return 